export enum KeycloakRole {
  Bike = 'employeesBike-access',
  Sunbeds = 'employeesSunbeds-access',
}
